import React from 'react';

import { IonRouterLink } from '@ionic/react';

import get from 'lodash/get';

import Typography from 'components/Typography';

import { IDescriptionLink } from './interfaces';

export const DescriptionLink: React.FC<IDescriptionLink> = ({
  value,
  linkLabelField,
  ...other
}) => {
  return (
    <IonRouterLink {...other}>
      <Typography>{get(value, linkLabelField, value)}</Typography>
    </IonRouterLink>
  );
};
